import * as React from 'react';
import clsx from 'clsx';
import {
  createStyles,
  makeStyles,
  useTheme,
  Theme
} from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import './AllStatus.scss';
import i18n from 'src/translation/i18n';
// });

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      maxWidth: 300
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    chip: {
      margin: 2
    },
    noLabel: {
      marginTop: theme.spacing(3)
    }
  })
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

const names = ['Open', 'In-Process', 'Past Due'];

function getStyles(name: string, personName: string[], theme: Theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium
  };
}

export default function MultipleSelectStatus(props: any) {
  const classes = useStyles();
  const theme = useTheme();
  const allStatusVal = [
    {
      name: i18n.t('invoices.pastDueStatus'),
      value: 'pastDue'
    },
    {
      name: i18n.t('invoices.openStatus'),
      value: 'open'
    },
    {
      name: i18n.t('invoices.pendingStatus'),
      value: 'pending'
    }
  ];
  const [personName, setPersonName] = React.useState<string[]>([]);
  const [allStatus, setAllStatus] = React.useState(allStatusVal);

  const { isReset, filter, invoiceSearch } = props;

  React.useEffect(() => {
    if (isReset) {
      setPersonName([]);
    }
  }, [isReset]);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setPersonName(event.target.value as string[]);
    filter(event.target.value);
  };
  const { getInvoices } = props;
  return (
    <div className="Instatus-container">
      <FormControl className={clsx(classes.formControl, classes.noLabel)}>
        <Select
          displayEmpty={true}
          value={personName}
          onChange={handleChange}
          MenuProps={MenuProps}
          inputProps={{ 'aria-label': 'Without label' }}
        >
          <MenuItem value="">{i18n.t('invoices.allStatus')}</MenuItem>
          {allStatus &&
            allStatus.length > 0 &&
            allStatus.map((val: any) => (
              <MenuItem value={val.value}>{val.name}</MenuItem>
            ))}
          {/* <MenuItem value={'process'}>In-process</MenuItem> */}
        </Select>
      </FormControl>
    </div>
  );
}
